import { HealthCheckClient } from "@cayo/shared/components/AppState/api/healthCheck";
import { endpoints } from "@cayo/shared/services/endpoints.service";

export const ServiceFactory = {
  HealthCheckService: new HealthCheckClient(endpoints.publicUrl),
};
